export default __webpack_public_path__ + "static/media/OroBG.013a0033.jpg";